<template>
    <v-app id="inspire">
        <v-snackbar top timeout="30000" v-model="showUpdateMessage" color="#fcba03">
            <v-icon>mdi-update</v-icon><span class="font-weight-bold pl-2"> A new update has been released. Reloading application in {{ timer }} seconds! </span>
        </v-snackbar>
        <v-navigation-drawer v-if="usermail" v-model="drawer" app clipped :expand-on-hover="expand">
            <v-list shaped nav dense>
                <v-list-item style="height: 40px !important;" color="primary" v-for="item in items" :key="item.text" link :to="item.redirect" @click="item.model = false">
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- <v-list-group
            :value='true'
            color="primary"
            v-for="item in dropItems"
            :key="item.text"
            v-model="item.model"       
            :prepend-icon="item.icon"
          >
            <template v-slot:activator v-if="item.visib">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              @click="item.model = false"
              :to='child.redirect'      
            >
            
               <v-list-item-icon v-if="child.icon && item.visib" id="subnavIcon">
                    <v-icon small>{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content v-if="item.visib">
                  <v-list-item-title id="subnavText">
                    {{ child.text }}
                  </v-list-item-title>
              </v-list-item-content>
            
             
            </v-list-item>           
          </v-list-group> -->

                <!-- <v-subheader class="mt-4 grey--text text--darken-1">SUBSCRIPTIONS</v-subheader> -->
                <v-divider dark class="my-4"></v-divider>
                <v-spacer></v-spacer>
                <!-- <v-list-item
          class="mt-4"
          link
          to='/settings'
        >
          <v-list-item-action>
            <v-icon color="grey lighten-1">mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-title class="grey--text text--darken-1">Settings</v-list-item-title>
        </v-list-item>  -->

                <v-list-item class="mt-4" link to="/logout">
                    <v-list-item-action>
                        <v-icon color="grey lighten-1">mdi-logout-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-title class="grey--text text--darken-1">Logout</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app clipped-left dense v-if="usermail">
            <v-app-bar-nav-icon @click.stop="shownav" color="primary"></v-app-bar-nav-icon>
            <v-img src="./assets/icon.png" id="sidebarLogo" class="sidebarLogo" @click="$route.path !== '/' ? $router.push('/') : idle"></v-img>
            <v-toolbar-title class="mr-12 align-center sidebarLogo" @click="$route.path !== '/' ? $router.push('/') : idle">
                <v-img src="./assets/logo-text.png" id="logotext"></v-img>
                <!-- <v-img src="./assets/quaro_1cedb2_logo.png" id="quarologo"></v-img> -->
            </v-toolbar-title>
            ADMIN
            <v-spacer></v-spacer>
            <v-chip small v-if="usermail">
                <v-avatar left>
                    <v-icon>
                        mdi-account
                    </v-icon>
                    <!-- <img :src="resolve_img_url" class="tablelogos"/> -->
                </v-avatar>
                {{ usermail }}
            </v-chip>
            <!-- <v-row
        align="center"
        style="max-width: 650px"
      >
        <v-text-field
          :append-icon-cb="() => {}"
          placeholder="Search..."
          single-line
          append-icon="mdi-magnify"
          color="orange darken-3"
          hide-details
        ></v-text-field>
      </v-row> -->

            <!-- notifications -->

            <v-menu v-model="showmenu" rounded :close-on-content-click="false" app clipped offset-y left v-if="usermail">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="mr-2 ml-4" @click="showmenu = true">
                        <v-badge id="badge" x-small :content="messages" :value="messages" color="green" overlap>
                            <v-icon v-bind="attrs" v-on="on" class="">mdi-bell-outline</v-icon>
                        </v-badge>
                    </v-btn>
                </template>
                <v-list id="notificationlist" v-if="notifications.length">
                    <v-list-item v-for="(notification, index) in notifications" :key="index" class="notification ml-auto" @click="clickNotification(notification)">
                        <v-list-item-title>
                            <v-row>
                                <div class=" mx-3 py-auto my-auto">
                                    <v-avatar color="#f7f7f7">
                                        <v-icon :color="notification.icon_color"> {{ notification.icon }}</v-icon></v-avatar
                                    >
                                </div>
                                <v-col class="py-auto my-auto nofitificationtext">
                                    <v-row
                                        ><span class="listname"> {{ notification.listname }}</span></v-row
                                    >
                                    <v-row class="message">
                                        {{ notification.message }}
                                    </v-row>
                                    <v-row class="date">
                                        {{ notification.date }}
                                    </v-row>
                                </v-col>
                                <div class="mx-3 py-auto my-auto">
                                    <v-btn v-if="notification.type !== '1'" icon class="ml-auto" @click="deleteNotification(notification.id)">
                                        <v-icon color="primary">mdi-close</v-icon>
                                    </v-btn>
                                </div>
                            </v-row>
                            <v-progress-linear :class="notifications.length > 1 ? 'mb-2' : ''" v-if="notification.type == '1'" v-model="notification.progress" query rounded></v-progress-linear>
                            <hr id="notificationline" class="mr-2" v-if="notifications.length > 1 && index != notifications.length - 1" />
                        </v-list-item-title>
                    </v-list-item>
                </v-list>

                <!-- no notifications -->
                <v-list id="notificationlist" v-else>
                    <v-list-item>
                        <v-list-item-title>
                            <v-row>
                                <v-col class="py-auto my-auto">
                                    <v-icon :color="noNotifications.icon_color"> {{ noNotifications.icon }}</v-icon>
                                </v-col>
                                <v-col class="py-auto my-auto nofitificationtext">
                                    {{ noNotifications.message }}
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-btn v-if="usermail" icon class="mr-2" @click="$router.push('/logout')">
                <v-icon class="">mdi-logout-variant</v-icon>
            </v-btn>
            <!-- <interactive-hints></interactive-hints> -->
        </v-app-bar>

        <v-main id="content">
            <!-- <v-container class="fill-height"> -->
            <div id="contentcontainter">
                <router-view></router-view>
            </div>
        </v-main>
        <dashboard-core-settings v-if="usermail" v-model="expandOnHover" />
    </v-app>
</template>
<script>
    import sound from "./assets/audio/notification-sound.mp3"
    import dashicon from "./assets/icons/__Dashboard.svg"
    export default {
        props: {
            source: String
        },
        components: {
            DashboardCoreSettings: () => import("./components/Settings"),
            InteractiveHints: () => import("./components/InteractiveHints")
        },
        data: () => ({
            query: false,
            expand: true,
            timer: 30,
            showUpdateMessage: false,
            soundPath: "./assets/audio/notification-sound.mp3",
            messages: 0,
            expandOnHover: false,
            drawer: true,
            showmenu: false,
            notifications: [],
            noNotifications: { message: "No notifications here for you!", icon: "mdi-emoticon-outline", icon_color: "green" },
            items: [
                { icon: "mdi-view-dashboard", text: "Dashboard", redirect: "/" },
                { icon: "mdi-office-building-outline", text: "Companies", redirect: "/admin/companies" },
                { icon: "mdi-account-group-outline", text: "User", redirect: "/admin/user" },
                { icon: "mdi-alpha-c-circle-outline", text: "Credits", redirect: "/admin/credits" },
                { icon: "mdi-account-plus", text: "Registrations", redirect: "/admin/registrations" }
            ],

            get usermail() {
                if (localStorage.getItem("user")) {
                    if (localStorage.getItem("user") != "[object Object],[object Object]") {
                        // //console.log(localStorage.getItem('user'))
                        return localStorage.getItem("user")
                    } else {
                        return
                    }
                } else {
                    return
                }
            },
            get plan() {
                if (localStorage.getItem("plan")) {
                    if (localStorage.getItem("plan") != "[object Object],[object Object]") {
                        // //console.log(localStorage.getItem('user'))
                        return localStorage.getItem("plan")
                    } else {
                        return
                    }
                } else {
                    return
                }
            }
        }),
        methods: {
            clickNotification(notification) {
                if (notification.type == "2") {
                    this.$router.push("/brand-index/" + notification.listname)
                }
            },
            shownav() {
                console.log(this.drawer)
                console.log(this.expand)
                if (this.drawer) {
                    this.expand = !this.expand
                } else {
                    this.drawer = !this.drawer
                }
                // this.drawer = !this.drawer
                // this.expand = !this.expand
            },
            idle() {},
            playNotificationSound() {
                const audio = new Audio(sound)
                audio.play()
            },
            createNotification(data) {
                let notificationObject
                if (data.type == "0") {
                    //type 0 = error
                    notificationObject = {
                        type: data.type,
                        message: data.message,
                        icon: "mdi-alert-circle",
                        icon_color: "red",
                        listname: data.listname,
                        date: this.getDateTime(),
                        id: data.id
                    }
                    for (let index = 0; index < this.notifications.length; index++) {
                        if (this.notifications[index].id == data.id) {
                            this.notifications.splice(index, 1)
                            this.messages--
                        }
                    }
                } else if (data.type == "1") {
                    //type 1 = branddashboard is creating
                    notificationObject = {
                        type: data.type,
                        message: data.message,
                        icon: "mdi-clock",
                        icon_color: "orange",
                        progress: 0,
                        listname: data.listname,
                        date: this.getDateTime(),
                        id: data.id
                    }
                } else if (data.type == "2") {
                    //type 1 = branddashboard created
                    // remove id and push new notification
                    for (let index = 0; index < this.notifications.length; index++) {
                        if (this.notifications[index].id == data.id) {
                            this.notifications.splice(index, 1)
                            this.messages--
                        }
                    }
                    notificationObject = {
                        type: data.type,
                        message: data.message,
                        icon: "mdi-comment-check",
                        icon_color: "green",
                        listname: data.listname,
                        date: this.getDateTime(),
                        id: data.id
                    }
                } else if (data.type == "3") {
                    //type 3 = progress update
                    console.log(this.notifications)
                    for (let index = 0; index < this.notifications.length; index++) {
                        if (this.notifications[index].id == data.id) {
                            this.notifications[index].progress = data.progress
                            console.log(this.notifications)
                        }
                    }
                    return null
                    // notificationObject = {
                    //   message: data.message,
                    //   icon: 'mdi-comment-check',
                    //   icon_color: 'green',
                    //   listname: data.listname,
                    //   date: this.getDateTime(),
                    //   id: Math.floor(Math.random() * 999)
                    // }
                }
                return notificationObject
            },
            getDateTime() {
                let dateTime = new Date()
                let month = dateTime.getMonth() + 1
                let day = dateTime.getDate()
                let hours = dateTime.getHours()
                let minutes = dateTime.getMinutes()
                return day + "." + month + " | " + hours + ":" + minutes
            },
            deleteNotification(id) {
                for (let index = 0; index < this.notifications.length; index++) {
                    if (this.notifications[index].id == id) {
                        this.notifications.splice(index, 1)
                        this.messages--
                    }
                }
            },
            resolve_img_url() {
                return "https://eu.ui-avatars.com/api/?name=" + this.usermail
            }
        },
        created() {},
        updated() {
            if (this.plan == 1) {
                for (let dropItemsCounter = 0; dropItemsCounter < this.dropItems.length; dropItemsCounter++) {
                    if (this.dropItems[dropItemsCounter].text == "Dashboards") {
                        this.dropItems.splice(dropItemsCounter, 1)
                    }
                }
                this.dropItems.length = 1
            }
        },
        mounted() {
            //  let not = this.createNotification({message: 'Your Dashboard has been created', listname: 'Test List 1',  icon_color: 'green', type: '1'})
            //  //console.log(not)
            //  this.notifications.push(not)
            //   let not2 = this.createNotification({message: 'Your Dashboard has been created', listname: 'Test List 2',  icon_color: 'green', type: '1'})
            //  //console.log(not2)
            //  this.notifications.push(not2)
            // this.$socket.on("getNotification", data =>{
            //   //console.log(data.message)
            //   let notificationObject = this.createNotification(data)
            //   if (notificationObject) {
            //     this.notifications.unshift(notificationObject)
            //     this.showmenu = false
            //     this.messages++
            //     this.showmenu = true
            //     this.playNotificationSound()
            //   }
            // })
            // this.$socket.on("showReloadmessage", data =>{
            //   console.log("Refreshing frontend initiated...showing message")
            //   this.showUpdateMessage = true;
            //   setInterval(() => {
            //     if(this.timer > 0){
            //       this.timer --
            //     }
            //   }, 1000);
            // })
            // this.$socket.on("reloadFrontend", data =>{
            //   console.log("Refreshing frontend...")
            //   this.$router.go();
            // })
        }
    }
</script>
<style>
    .notification:hover {
        background-color: #e9e9e9;
    }
    .nofitificationtext {
        font-family: Raleway;
    }
</style>
<style scoped lang="scss">
    #notificationline {
        margin-left: 60px !important;
        border-radius: 5px;
        border: 1px solid rgb(228, 228, 228);
    }
    .message {
        font-size: 0.9em;
    }
    .date {
        font-size: 0.8em;
    }
    .listname {
        font-weight: bold;
        font-size: 0.9em;
    }
    .v-badge__badge {
        margin-top: 20px;
    }
    .v-list-group__header {
        height: 100px !important;
    }
    #quarologo {
        max-width: 105px;
    }
    #logotext {
        max-width: 150px;
        padding-left: 10px;
        margin-top: 1px !important;
    }
    #sidebarLogo {
        margin-left: 5px;
        margin-right: 5px;
        max-width: 50px;
    }
    .sidebarLogo:hover {
        cursor: pointer;
    }
    #navtitle {
        font-weight: bold;
        margin-top: 9px !important;
        margin-left: 0px;
        color: rgb(88, 88, 88);
        font-size: 13px !important;
    }
    #content {
        background-color: var(--v-background-base);
    }
    #contentcontainter {
        margin: auto;
        width: 90%;
        padding-top: 30px;
    }
    #subnavIcon {
        padding-left: 39px;
        padding-right: 0px;
        margin-right: 10px;
    }
    #subnavText {
        padding-left: 0px !important;
    }
    // #notificationlist{}
</style>
